import React from 'react';
import { Tooltip } from '@material-ui/core';
import { OpenInNewRounded } from '@material-ui/icons';
import { safeEcomOrderUrl } from '../../../../../../../jsx/utils/ecomSale';

// Badge d'origine e-commerce, partagé par l'onglet Commandes et l'historique des mouvements.
const LIBELLES_SOURCE = {
    prestashop: 'PrestaShop',
};

const STYLE_BADGE = { background: '#e8f5e9', color: '#2e7d32', padding: '2px 8px', borderRadius: 4, fontSize: 12, fontWeight: 600 };

// Avec `url` (adresse de la commande dans l'administration de la boutique), le badge devient un
// lien ouvert dans un nouvel onglet ; une adresse qui n'est pas en http(s) est ignorée.
export default function EcomSourceBadge({ source = 'prestashop', url }) {
    const cle = String(source || '').trim().toLowerCase();
    const libelle = LIBELLES_SOURCE[cle] || source;
    const href = safeEcomOrderUrl(url);
    if (!href) {
        return <span style={STYLE_BADGE}>{libelle}</span>;
    }
    return (
        <Tooltip title="Ouvrir la commande dans l'administration PrestaShop">
            <a href={href} target="_blank" rel="noopener noreferrer"
                style={{ ...STYLE_BADGE, textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                {libelle}
                <OpenInNewRounded style={{ fontSize: 12 }} />
            </a>
        </Tooltip>
    );
}
